<template>
  <transition name="modal">
    <div class="modal-mask" v-if="show">
      <div class="modal-wrapper">
        <div class="modal-container small">
          <div class="modal-header">
            <h4><b>{{ title }}</b></h4>
          </div>

          <div class="modal-body">
            <slot> </slot>
          </div>

          <div class="modal-footer">
            <button class="btn btn-primary" @click="onClick()"> {{ positiveText }} </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    positiveText: {
      type: String,
      default: "Aceptar"
    },
    title: {
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    onClick() {
      this.$emit('pressed-ok');
    },
  }
}
</script>

<style scoped>
.modal {
  color: black;
}
</style>


// WEBPACK FOOTER //
// InfoModal.vue?56cd79b7